import { ReactNode } from "react";
import { Home } from "@mui/icons-material";

export type MenuItem = {
    id: string;
    type?: 'default' | 'separator';
    label?: string;
    route?: string;
    side?: 'left' | 'right';
    children?: MenuItem[];
}

export type SubmenuItem = {
    id: string;
    label?: string;
    icon?: ReactNode;
    route?: string;
    hideFlyout?: boolean;
}

export type MobileMenuItem = {
    id: string;
    type?: 'default' | 'separator';
    label?: string;
    route?: string;
    hasFlyout?: boolean;
}

export const MENU_ITEMS: MenuItem[] = [
    {
        id: 'exhibitions',
        label: 'Ausstellungen',
        side: 'left',
        children: [
            {
                id: 'permanent-exhibitions',
                label: 'Dauerausstellungen',
                route: '/exhibitions'
            },
            {
                id: 'special-exhibitions',
                label: 'Sonderausstellungen',
                route: '/special-exhibitions'
            },
        ]
    },
    {
        id: 'placement-services',
        label: 'Vermittlungsangebote',
        side: 'left',
        children: [
            {
                id: 'guided-tours',
                label: 'Führungen',
                route: '/guided-tours'
            },
            {
                id: 'education',
                label: 'Museumspädagogik und Angebote für Schulen',
                route: '/education'
            },
            {
                id: 'authentic-places',
                label: 'Authentische Orte',
                route: '/authentic-places'
            },
        ]
    },
    {
        id: 'our-museum',
        label: 'Unser Museum',
        side: 'left',
        children: [
            {
                id: 'collection',
                label: 'Unsere Sammlung',
                route: '/collection'
            },
            {
                id: 'archive',
                label: 'Foto- und Bildarchiv',
                route: '/foto-und-bildarchiv'
            },
            {
                id: 'city-curator',
                label: 'Stadtheimatpfleger',
                route: '/city-curator-archaeology',
            },
            {
                id: 'history',
                label: 'Haus- und Museumsgeschichte',
                route: '/history'
            },
        ]
    },
    {
        id: 'research',
        route: '/research',
        label: 'Forschungsprojekte',
        side: 'right'
    },
    {
        id: 'shop',
        route: '/shop',
        label: 'Shop & Café',
        side: 'right'
    },
    {
        id: 'cooperations',
        route: '/cooperations',
        label: 'Kooperationspartner',
        side: 'right'
    }
]

export const SUBMENU_ITEMS: SubmenuItem[] = [
    {
        id: 'home',
        label: 'Startseite',
        route: '/',
        icon: <Home />,
        hideFlyout: true,
    },
    {
        id: 'opening-hours',
        label: 'Öffnungszeiten',
    },
    {
        id: 'entrance-fee',
        label: "Preise",
    },
    {
        id: 'events',
        label: 'Veranstaltungen',
    },
    {
        id: 'event-locations',
        label: 'Veranstaltungsräume',
    },
    {
        id: 'approach',
        label: 'Anfahrt',
    },
    {
        id: 'a11y',
        label: 'Barrierefreiheit',
    },
    {
        id: 'newsletter',
        label: 'Newsletter',
    },
    {
        id: 'contact',
        label: 'Kontakt',
    }
]

export const MOBILE_MENU_ITEMS: MobileMenuItem[] = [
    {
        id: 'home',
        label: 'Startseite',
        route: '/',
    },
    {
        id: 'history',
        label: 'Haus-und Museumsgeschichte',
        route: '/history',
    },
    {
        id: 'guided-tours',
        label: 'Führungen',
        route: '/guided-tours',
    },
    {
        id: 'exhibitions',
        label: 'Ausstellungen',
        route: '/exhibitions',
    },
    {
        id: 'special-exhibitions',
        label: 'Sonderausstellungen',
        route: '/special-exhibitions',
    },
    {
        id: 'education',
        label: 'Museumspädagogik und Angebote für Schulen',
        route: '/education',
    },
    {
        id: 'collection',
        label: 'Unsere Sammlung',
        route: '/collection',
    },
    {
        id: 'archive',
        label: 'Foto- und Bildarchiv',
        route: '/foto-und-bildarchiv',
    },
    {
        id: 'research',
        label: 'Forschung',
        route: '/research',
    },
    {
        id: 'shop',
        label: 'Shop & Café',
        route: '/shop',
    },
    {
        id: 'authentic-places',
        label: 'Authentische Orte',
        route: '/authentic-places',
    },
    {
        id: 'city-curator-archaeology',
        label: 'Stadtheimatpfleger Archäologie',
        route: '/city-curator-archaeology',
    },
    {
        id: 'cooperations',
        label: 'Kooperationspartner',
        route: '/cooperations',
    },
    {
        id: 'seperator',
        type: 'separator',
    },
    {
        id: 'opening-hours',
        label: 'Öffnungszeiten',
        hasFlyout: true,
    },
    {
        id: 'entrance-fee',
        label: 'Preise',
        hasFlyout: true,
    },
    {
        id: 'events',
        label: 'Veranstaltungen',
        hasFlyout: true,
    },
    {
        id: 'event-locations',
        label: 'Veranstaltungsräume',
        hasFlyout: true,
    },
    {
        id: 'approach',
        label: 'Anfahrt',
        hasFlyout: true,
    },
    {
        id: 'a11y',
        label: 'Barrierefreiheit',
        hasFlyout: true,
    },
    {
        id: 'newsletter',
        label: 'Newsletter',
        hasFlyout: true,
    },
    {
        id: 'contact',
        label: 'Kontakt',
        hasFlyout: true,
    },
]